import { useStores } from 'hooks/useStores'
import { getTranslatedTextByKey } from 'utils/language'
import { sendCustomEvent } from 'utils/analytics/analytics'
import OrderTypeButton from './OrderTypeButton'
import { OrderTypeFlow } from 'mobx/Localization/types'
import {
	StyledArrowBack,
	StyledCloseButton,
	StyledCloseIcon,
	StyledOrderTypesContainer,
	StyledOrderTypeSelectionContainer,
	StyledOrderTypeSelectionHeader,
	StyledOrderTypeSelectionTitle,
} from './styles'

const OrderTypeSelection = () => {
	const { localizationStore } = useStores()
	const titleText = getTranslatedTextByKey('webflow.selectOrderingMethod', 'Select ordering method')

	const onSelectFlow = (flow: OrderTypeFlow) => {
		localizationStore.processingFlow?.setOrderTypeFlow(flow)
		localizationStore.nextStep()

		sendCustomEvent({
			category: 'address box',
			action: 'button clicked',
			label: flow.orderType,
		})
	}

	return (
		<StyledOrderTypeSelectionContainer>
			<StyledOrderTypeSelectionHeader>
				{localizationStore.editing && <StyledArrowBack onClick={localizationStore.edit} />}
				<StyledOrderTypeSelectionTitle variant="SubheadHighlighted">{titleText}</StyledOrderTypeSelectionTitle>
				<StyledCloseButton>
					<StyledCloseIcon onClick={localizationStore.abort} />
				</StyledCloseButton>
			</StyledOrderTypeSelectionHeader>
			<StyledOrderTypesContainer>
				{localizationStore.orderTypeFlows.map((orderTypeFlow) => (
					<OrderTypeButton flow={orderTypeFlow} onSelectFlow={onSelectFlow} key={orderTypeFlow.orderType} />
				))}
			</StyledOrderTypesContainer>
		</StyledOrderTypeSelectionContainer>
	)
}

export default OrderTypeSelection
